export default __webpack_public_path__ + "static/media/circle-blue.42e0b029.svg";